import React, {useCallback} from 'react';
import {Modal, Text, Icon} from '@/ui-kits';
import {NA} from '@/constants/defaults';
import {JsonDiffViewer} from './JsonDiffViewer';

interface JsonValueModalProps {
  open: boolean;
  onClose: () => void;
  value: any;
  title: string;
  oldValue?: any;
}

const parseJsonValue = (value: any): any => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'object') return value;
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};

export const JsonValueModal: React.FC<JsonValueModalProps> = ({open, onClose, value, title, oldValue}) => {
  const formatModalValue = useCallback((val: any): string => {
    const parsed = parseJsonValue(val);
    if (parsed === null || parsed === undefined) return 'null';
    if (typeof parsed === 'string') return parsed;
    return JSON.stringify(parsed, null, 2);
  }, []);

  const shouldShowDiff = oldValue !== undefined && oldValue !== null && value !== null && value !== undefined;
  const formattedValue = !shouldShowDiff && value !== null && value !== undefined ? formatModalValue(value) : NA;

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="relative bg-white py-4 px-6 rounded-xl gap-6 w-[90vw] max-w-[900px] max-h-[90vh] overflow-y-auto">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 size-8 flex items-center justify-center rounded-full hover:bg-gray-100 z-10">
        <Icon type="close" className="size-5 text-ui_blue" />
      </button>

      <div>
        <Text variant="body" className="!text-deep_blue !font-FigtreeSemiBold mb-4 !text-xl">
          {title}
        </Text>
        {shouldShowDiff ? (
          <JsonDiffViewer
            oldValue={oldValue}
            newValue={value}
            showOldValue={true}
            showOnlyChanges={true}
            showParsedView={false}
          />
        ) : (
          <div className="bg-ui_sky_blue rounded-lg p-4 border border-ui_input_border">
            <pre className="text-xs font-mono overflow-x-auto whitespace-pre-wrap break-words">
              {formattedValue}
            </pre>
          </div>
        )}
      </div>
    </Modal>
  );
};
